import React from 'react';

const SendLoadingBox = () => {
  return (
    <div className="py-[5px] w-full my-[5px] text-left sendLoadingBox">
      <div className="circleWrap">
        <div className="circle"></div>
        <div className="circle transparent"></div>
      </div>
    </div>
  );
};

export default SendLoadingBox;